import { useI18n } from '@/i18n/i18n-react'
import { Button } from './ui/button'
import { cn } from '@/lib/utils'

export const ErrorDisplay = ({
	refetch,
	title,
	description,
	buttonText,
	className
}: {
	refetch: () => void
	className?: string
	title?: string
	description?: string
	buttonText?: string
}) => {
	const { L } = useI18n()
	return (
		<div className={cn('text-center', className)}>
			<div className='mx-auto max-w-md'>
				<div className='rounded-lg border border-destructive bg-destructive/5 p-6'>
					<h3 className='mb-2 font-semibold text-destructive'>{title || L.Common.States.Error()}</h3>
					<p className='text-sm text-destructive/80'>{description || L.Errors.Generic()}</p>
					<Button variant='outline' size='sm' className='mt-4' onClick={refetch}>
						{buttonText || L.Common.Actions.Retry()}
					</Button>
				</div>
			</div>
		</div>
	)
}
